exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-slate {\n  padding: 1rem 1rem 3rem !important;\n  color: #777777 !important; }\n", ""]);

// exports
